// First-party, consent-gated visitor analytics tracker.
// No cookies — a localStorage visitor id + sessionStorage session id.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CONSENT_KEY = "cre_analytics_consent"; // "granted" | "denied"
const VISITOR_KEY = "cre_visitor_id";
const SESSION_KEY = "cre_session_id";
const HEARTBEAT_SECONDS = 15;
const MAX_HEARTBEATS = 80; // ~20 min per page max

let currentViewId = null;
let heartbeatTimer = null;
let heartbeatCount = 0;
let lastTracked = { path: null, at: 0 };

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (_) {
    return "denied";
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch (_) {
    /* storage unavailable */
  }
}

function rand() {
  return (
    Date.now().toString(36) + Math.random().toString(36).slice(2, 12)
  );
}

function visitorId() {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) {
    v = `v_${rand()}`;
    localStorage.setItem(VISITOR_KEY, v);
  }
  return v;
}

function sessionId() {
  let s = sessionStorage.getItem(SESSION_KEY);
  if (!s) {
    s = `s_${rand()}`;
    sessionStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
}

function startHeartbeat() {
  stopHeartbeat();
  heartbeatCount = 0;
  heartbeatTimer = setInterval(() => {
    if (!currentViewId || document.visibilityState !== "visible") return;
    heartbeatCount += 1;
    if (heartbeatCount > MAX_HEARTBEATS) {
      stopHeartbeat();
      return;
    }
    axios
      .post(`${API}/track/heartbeat`, {
        view_id: currentViewId,
        seconds: HEARTBEAT_SECONDS,
      })
      .catch(() => {});
  }, HEARTBEAT_SECONDS * 1000);
}

export async function trackPageview(path) {
  if (getConsent() !== "granted" || path.startsWith("/admin")) {
    // Stop counting time against the previous public page.
    stopHeartbeat();
    currentViewId = null;
    return;
  }
  // Guard against React StrictMode double-mount firing twice.
  const now = Date.now();
  if (lastTracked.path === path && now - lastTracked.at < 1500) return;
  lastTracked = { path, at: now };
  try {
    const r = await axios.post(`${API}/track/pageview`, {
      visitor_id: visitorId(),
      session_id: sessionId(),
      path,
      referrer: document.referrer || "",
    });
    currentViewId = r.data?.view_id || null;
    // Guard: user may have navigated to /admin while this POST was in flight.
    if (window.location.pathname.startsWith("/admin")) {
      currentViewId = null;
      return;
    }
    startHeartbeat();
  } catch (_) {
    /* analytics must never break the app */
  }
}
